// Generated by `npm run generate:models` from src/model-registry.mjs. Do not edit.
export type ModelChoice = 'auto' | 'opus' | 'sonnet' | 'haiku' | 'sol';
export const MODEL_CHOICE_ORDER: ModelChoice[] = ['auto', 'opus', 'sonnet', 'haiku', 'sol'];
export const MODEL_CHOICE_COPY: Record<ModelChoice, { name: string; description: string }> = {
  "auto": {
    "name": "Auto",
    "description": "Haiku 5.5, with Sonnet 5.5 when Haiku is unavailable. Both run in the EU."
  },
  "opus": {
    "name": "Opus 5.5",
    "description": "For the hardest analysis, coding and long-running work."
  },
  "sonnet": {
    "name": "Sonnet 5.5",
    "description": "For everyday work, analysis and writing."
  },
  "haiku": {
    "name": "Haiku 5.5",
    "description": "Fast, lower-cost answers and everyday tasks."
  },
  "sol": {
    "name": "Sol",
    "description": "For work that needs judgment and deeper analysis."
  }
};
export const PROCESSING_MODEL_LABELS = {"eu":"Claude Haiku 5.5","global":"Claude Haiku 5.5"};
export const AUTO_FALLBACK_MODEL_LABEL = "Claude Sonnet 5.5";
export const ANSWERING_MODEL_LABELS: Record<string, string> = {"global.openai.gpt-5.6-luna":"Luna 5.6","eu.anthropic.claude-sonnet-5":"Sonnet 5","eu.anthropic.claude-opus-5-5":"Claude Opus 5.5","eu.anthropic.claude-sonnet-5-5":"Claude Sonnet 5.5","eu.anthropic.claude-haiku-5-5":"Claude Haiku 5.5","global.openai.gpt-6-luna":"Luna 6","global.openai.gpt-6-astra":"Astra 6","global.openai.gpt-6-sol":"Sol 6","openai/gpt-5.6-luna":"Luna 5.6 (OpenRouter)"};
